import { render, staticRenderFns } from "./Individuales.vue?vue&type=template&id=1ba2a655"
import script from "./Individuales.vue?vue&type=script&lang=js"
export * from "./Individuales.vue?vue&type=script&lang=js"
import style0 from "./Individuales.vue?vue&type=style&index=0&id=1ba2a655&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports